import {getFormReducerWithActions} from "../common/form";


const {reducer, ...actions} = getFormReducerWithActions('currentImportedDuplicate');


export const currentImportedDuplicateReducer = reducer;
export const currentImportedDuplicateActions = actions;